import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { GetData } from '../../services/GetData';
import { PostData } from '../../services/PostData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Badge,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import AcademicPage from '../../views/AcademicPage/';
import Loader from "../../Loader";
import $ from 'jquery';

const GLOBAL = require('../../Globals');

const txtupper = {

	textTransform: 'uppercase',
	fontSize: '20px'
}

class Bonafidecert extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			loading: false,
			stdregno: '',
			accyear: '',
			view: '0',
			scholar: '',
			iscomposed: '0',
			showgen: '2',
			bdata: [],
			bdate: '',
			allcourses: [],
		}
		this.onRegnoSearchChange = this.onRegnoSearchChange.bind(this);
		this.onView = this.onView.bind(this);
		this.onGenerate = this.onGenerate.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.printDocument = this.printDocument.bind(this);
	}

	printDocument() {

		var content = document.getElementById("showdata");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	onGenerate(e) {

		this.setState({ showgen: '1' });
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		if (this.state) {

			PostData('student/storebonafide', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					alert('Bonafied Certificate Generated Successfully');

					this.setState({ showgen: '2' });
					document.getElementById("bform").reset();
					this.getdata();
					this.getbonafide();

				}
				else {

					alert('Error');
					this.setState({ showgen: '2' });
					document.getElementById("bform").reset();
					this.getdata();
					this.getbonafide();
				}
			});

		}

	}

	// Get Bonafide Certificate Details
	getbonafide() {

		GetData('student/getbonafide/' + this.state.accyear + '/' + this.state.stdregno).then((result) => {
			let responseJson = result;
			if (responseJson && responseJson.length > 0) {
				this.setState({
					bdata: responseJson,
					bdate: responseJson[0]['issuedate']
				});
			}
		});
	}

	handleChange(e) {

		this.setState({ [e.target.name]: e.target.value });
	}

	onView(e) {

		this.setState({ view: '1' });
		this.getdata();
	}

	onRegnoSearchChange(e) {

		this.state.stdregno = e.target.value;
	}



	componentWillMount() {

		//this.getdata();
		this.getacyear();
	}

	getacyear() {
		$("#showLoader").show();
		GetData('student/getcurrentacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
			}
		});
	}


	// Get Details
	getdata() {
		this.setState({ data: [], loading: true });
		$("#showLoader").show();
		GetData('student/getstudbyid/' + this.state.accyear + '/' + this.state.stdregno).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({
					url: res[0]['photo'],
					name: res[0]['studentname'],
					regno: res[0]['regno'],
					acname: res[0]['acname'],
					emisno: res[0]['emisno'],
					admissionno: res[0]['admissionno'],
					rollno: res[0]['rollno'],
					aadhar: res[0]['aadharno'],
					cls: res[0]['cls'],
					sec: res[0]['sec'],
					dob: res[0]['dob'],
					gender: res[0]['gender'],
					bldgrp: res[0]['bloodgroup'],
					communi: res[0]['comm'],
					caste: res[0]['cast'],
					nation: res[0]['nationality'],
					mtongue: res[0]['mothertongue'],
					address: res[0]['presentaddr'],
					mobile: res[0]['mobile'],
					email: res[0]['email'],
					father: res[0]['fathername'],
					mother: res[0]['mothername'],
					country: res[0]['country'],
					state: res[0]['state'],
					city: res[0]['city'],
					religion: res[0]['rel'],
					identify1: res[0]['identify1'],
					identify2: res[0]['identify2'],
				});
			}
			this.setState({ loading: false });
			this.getbonafide();
		});

	}



	getcurrendate() {

		var date2 = new Date();
		var year = date2.getFullYear();
		var month = (date2.getMonth() + 1);
		var day = date2.getDate()
		const strDate = day + '.' + month + '.' + year;

		return strDate;
	}

	getbondate(dob) {

		var emptydob = '';
		if (dob != '') {
			var ed = new Date(dob);
			var edate = ed.setDate(ed.getDate());

			var d = new Date(edate),
				month = '' + (d.getMonth() + 1),
				day = '' + (d.getDate()),
				year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			return [day, month, year].join('-');
		}
		else {

			return emptydob;
		}
	}

	render() {

		// Get Login User Id
		this.state.user = sessionStorage.getItem('userData');
		this.state.user = JSON.parse(this.state.user);
		this.state.userId = this.state.user.userid;

		if (this.state.showgen == '1') {

			$(".genbtn").hide();
			$(".showgen").show();
		}
		else {

			$(".genbtn").show();
			$(".showgen").hide();
		}

		if (this.state.showgen == '1' && this.state.admissionno == '') {

			$(".showgenad").show();
		}
		else {

			$(".showgenad").hide();
		}




		if (this.state.view == '1') {

			$("#showdata").show();
			$(".genbtn").show();
		}
		else {

			$("#showdata").hide();
			$(".genbtn").hide();
		}

		var currentyear = (new Date()).getFullYear();
		var lastyear = (new Date()).getFullYear() - 1;
		var pastyear = (new Date()).getFullYear() - 2;

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Bonafide Certificate</strong>
								</CardHeader>
								<CardBody>
									<Row>
										<Col md="2" style={{ padding: '0px' }}>

										</Col>
										<Col md="1" style={{ padding: '0px' }}>
											<FormGroup>
												<Label>Register No</Label>
											</FormGroup>
										</Col>
										<Col md="2">
											<FormGroup>
												<input type="text" name="stdregno" className="form-control" onChange={this.onRegnoSearchChange} />
											</FormGroup>
										</Col>
										<Col md="3">
											<FormGroup>
												<Button id="viewbtn" color="primary" size="md" onClick={this.onView}>Find</Button>
											</FormGroup>
										</Col>

									</Row>
									<Row id="showdata">
										<Col md="12" style={{ paddingTop: '120px' }}>
											<Card style={{ border: '1px solid black', backgroundColor: '#e6ffe6' }}>
												<table>
													<tbody>
														<tr>
															<td rowSpan="4" width="170" align="right" style={{ paddingLeft: '90px', paddingRight: '10px' }}><img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} width="70" /></td>
														</tr>
														<tr>
															<td align="center" className="ctext">{GLOBAL.Sclful_NAME}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Addr}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Dist}</td>
														</tr>
													</tbody>
												</table>
												<table style={{ lineHeight: '40px', borderTop: '1px solid black', textAlign: 'center' }}>
													<tbody>
														<tr><td align="center" style={{ paddingTop: '20px' }}><b style={{ fontSize: '18px', border: '3px double black', padding: '3px' }}>BONAFIDE CERTIFICATE</b></td></tr>
														<tr>
															<td style={{ fontSize: '16px', padding: '25px' }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This is to certify that Student <b style={{ fontSize: '16px' }}>{this.state.name} </b> {this.state.gender == 'Female' ? 'D/O' : 'S/O'}  {this.state.father} is a student of our School. {this.state.gender == 'Female' ? 'She' : 'He'} is studying <b>{this.state.cls} - {this.state.sec} </b> class during the year {this.state.acname}.</td>
														</tr>
														<tr>
															<td style={{ padding: '20px', fontSize: '18px' }}><span style={{ float: 'left' }}>Admission No : {this.state.admissionno} <br />
																Date :  {this.getbondate(this.state.bdate)} </span><span style={{ float: 'right' }}><br /> HEADMASTER </span></td>
														</tr>
													</tbody>
												</table>
											</Card>
										</Col>
										<iframe name="print_frame" id="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
									</Row>
									<form action="" method="post" role="form" id="bform" encType="multipart/form-data" onSubmit={this.onSubmit}>
										<Row>
											<Col md="1" className="showgen">
												<FormGroup>
													<Label>Applied By</Label>
												</FormGroup>
											</Col>
											<Col md="2" className="showgen">
												<FormGroup>
													<Input type="textarea" name="appliedby" onChange={this.handleChange} required />
												</FormGroup>
											</Col>
											<Col md="1" className="showgen">
												<FormGroup>
													<Label>Apply Date</Label>
												</FormGroup>
											</Col>
											<Col md="2" className="showgen">
												<FormGroup>
													<input type="date" name="applydate" onChange={this.handleChange} className="form-control" required />
												</FormGroup>
											</Col>
											<Col md="1" className="showgenad">
												<FormGroup>
													<Label>Admission No</Label>
												</FormGroup>
											</Col>
											<Col md="2" className="showgenad">
												<FormGroup>
													<input type="text" name="admno" onChange={this.handleChange} className="form-control" />
												</FormGroup>
											</Col>
											<Col md="1" className="showgen">
												<FormGroup>
													<Button style={{ float: 'right' }} size="sm" color="success">Save </Button>
												</FormGroup>
											</Col>
											{this.state.bdata.length > 0 ?
												<Col md="12">
													<FormGroup>
														<Button style={{ float: 'right' }} size="sm" color="warning" onClick={this.printDocument}>Print</Button>
													</FormGroup>
												</Col>
												:
												<Col md="12" className="genbtn">
													<FormGroup>
														<Button style={{ float: 'right' }} size="sm" color="success" onClick={this.onGenerate}>Generate</Button>
													</FormGroup>
												</Col>
											}
										</Row>
									</form>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

export default Bonafidecert;



// WEBPACK FOOTER //
// ./src/certificate/Bonafidecert/Bonafidecert.js